var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from '../framework/Framework';
import { Component } from '../framework/Component';
import { Lightbox } from '../tools/lighboxCompare';
export class InfoButton extends Component {
    constructor() {
        super('InfoButton', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            Lightbox.init();
            $('.button-info, .button-info-text').on('click', (event, button) => {
                event.preventDefault();
                Lightbox.load($(button).attr('href'));
            });
            //
            this.success();
        });
    }
}
